import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import './Counter.scss';

const Counter = ({ title, items }) => {
    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true,
    });

    return (
        <div ref={ref} className="Counter">
            {title && 
                <h2 className="Counter__Title">{title}</h2>
            }
            <div className="Counter__Content">
                {items.length > 0 && items.map((item, index) => {
                    const endNumber = inView ? item.itemNumber : 0;

                    return (
                        <div 
                            key={index} 
                            className="Counter__Section" 
                            style={{minWidth: `${item.itemNumber.toString().length * 65}px`}}
                        >
                            <CountUp 
                                className="Counter__Number" 
                                duration={3} 
                                end={endNumber} 
                            />
                            {item.itemTitle}
                        </div>
                    )
                })}
            </div>
        </div>
    );
};

Counter.propTypes = {
    title: PropTypes.string,
    items: PropTypes.any
};

Counter.defaultProps = {
    title: "",
    items: []
};

export default Counter;
